import { IconAlertTriangle } from '@tabler/icons-react';
import { EmptyState } from '@fololabs/design/components';
import { LauncherShell } from '../components/LauncherShell';

interface Props {
  message: string;
  onRetry: () => void;
}

/** Session-bootstrap failure (network / config). Offers a retry rather
 *  than stranding the user on a blank screen. */
export function ErrorState({ message, onRetry }: Props) {
  return (
    <LauncherShell>
      <EmptyState
        icon={IconAlertTriangle}
        title="Couldn't load your products"
        description={message}
        action={{ label: 'Try again', onClick: onRetry }}
      />
    </LauncherShell>
  );
}
